const API_URL = process.env.REACT_APP_API_URL;

export const getData = async (END_POINT) => {
  try {
    const response = await fetch(API_URL + END_POINT);
    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data: ", error.message);
  }
};

export const deleteData = async (END_POINT, errorMessage) => {
  try {
    const response = await fetch(API_URL + END_POINT, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete data: ${response.status}`);
    }

    window.location.reload();
    return;
  } catch (error) {
    console.error("Error deleting data:", error.message);
    alert(`${errorMessage + error.message}`);
  }
};

export const postData = async (END_POINT, data, errorMessage) => {
  try {
    const response = await fetch(API_URL + END_POINT, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to post data: ${response.status}`);
    }

    window.location.reload();
  } catch (error) {
    console.error("Error submitting form:", error.message);
    alert(`${errorMessage + error.message}`);
  }
};

export const updateData = async (END_POINT, data, errorMessage) => {
  try {
    const response = await fetch(API_URL + END_POINT, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to update data: ${response.status}`);
    }

    window.location.reload();
  } catch (error) {
    console.error("Error updating data:", error.message);
    alert(`${errorMessage + error.message}`);
  }
};
